<template>
	<draggable
		class="card dragArea"
		tag="ul"
		:list="tasks"
		:group="{ name: 'g1' }">
		<div v-for="(el, idx) in tasks" :key="el.id">
			<draggable-component
				:el="el"
				:parameters="parameters"></draggable-component>
			<b-button
				variant="link"
				@click="
					el.tasks.push({
						id: unique_id(),
						data: {},
						tasks: [],
						show: true,
						first_deep: el.deep + 1,
					})
				"
				><i class="fas fa-plus"></i
			></b-button>
			<i class="fa fa-times close" @click="removeAt(idx)"></i>
			<b-button
				variant="link"
				@click="el.show ? (el.show = false) : (el.show = true)"
				><i v-show="el.show" class="fas fa-chevron-down"></i
				><i v-show="!el.show" class="fas fa-chevron-right"></i
			></b-button>
			<nested-draggable
				v-show="el.show"
				:tasks="el.tasks"
				:id="el.id"
				:parameters="parameters" />
			<div v-show="!el.show">{{ el.tasks.length }} éléments</div>
		</div>
	</draggable>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";

	import draggableComponent from "./draggable_component";

	export default {
		props: {
			tasks: {
				required: true,
				type: Array,
			},
			parameters: {
				type: Object,
			},
			id: {
				type: String,
			},
		},
		components: {
			draggable,
			draggableComponent,
		},
		data() {
			return {
				intern_id: uniqueId(""),
			};
		},
		name: "nested-draggable",
		methods: {
			unique_id() {
				return uniqueId();
			},
			removeAt(idx) {
				this.tasks.splice(idx, 1);
			},
		},
	};
</script>
<style scoped>
	.dragArea {
		min-height: 10px;
	}
</style>
